module.exports = __webpack_public_path__ + "images/emoji/u7981.ad55826004f8bf852a26.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/u7981.png
// module id = 2g4N
// module chunks = 24